import { Link } from "react-router-dom";
import { formatTimeAgo } from "../../utils/time";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundAccordionTitle(_ref) {
  let {
    chainLogo,
    roundName,
    chainId,
    roundId,
    lastUpdated,
    formattedAmount,
    totalContributionAmountInUsd
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full flex items-center justify-between font-modern-era-regular font-normal text-base/[26px]",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-1 flex-1",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center",
        children: [/*#__PURE__*/_jsx("img", {
          className: "w-4 h-4 mr-1",
          src: chainLogo,
          alt: "Round Chain Logo"
        }), /*#__PURE__*/_jsx(Link, {
          className: `underline inline-block truncate`,
          title: roundName,
          to: `/round/${chainId}/${roundId.toLowerCase()}`,
          target: "_blank",
          children: roundName
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "text-sm text-left text-gray-500",
        children: formatTimeAgo(Number(lastUpdated))
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-1 text-center truncate",
      children: [/*#__PURE__*/_jsxs("span", {
        className: "text-black",
        children: [formattedAmount, " "]
      }), /*#__PURE__*/_jsxs("span", {
        className: "text-grey-400",
        children: ["/ $", totalContributionAmountInUsd.toFixed(2)]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-1"
    })]
  });
}